module.exports = {
  IdentifyClient: "IdentifyClient",
  Chat: "Chat",
  GetLoginToken: "GetLoginToken",
  AddLoginInfo: "AddLoginInfo",
  CheckLoginInfo: "CheckLoginInfo",
  MachineInfos: "MachineInfos",
  LoginGM: "LoginGM",
  LogoutGM: "LogoutGM",
  QueryUser: "QueryUser",
  CreateUser: "CreateUser",
  DeleteUser: "DeleteUser",
  QueryGM: "QueryGM",
  CreateGM: "CreateGM",
  DeleteGM: "DeleteGM",
  IncreaseGMCoins: "IncreaseGMCoins",
  SubtractGMCoins: "SubtractGMCoins",
  IncreaseUserCoins: "IncreaseUserCoins",
  SubtractUserCoins: "SubtractUserCoins",
  IncreaseUserTrialCoins: "IncreaseUserTrialCoins",
  SubtractUserTrialCoins: "SubtractUserTrialCoins",
  SaveUser: "SaveUser",
  SaveGM: "SaveGM",
  ChangePassword: "ChangePassword",
  ChangeUserInfo: "ChangeUserInfo",
  GetUserActions: "GetUserActions",
  RecordGMAction: "RecordGMAction",
  GetUnbillingAddSubCoinsRecords: "GetUnbillingAddSubCoinsRecords",
  RecordBill: "RecordBill",
  GetGMActions: "GetGMActions",
  GetBills: "GetBills",
  AddBroadcastMsg: "AddBroadcasrMsg",
  ModifyBroadcastMsg: "ModifyBroadcasrMsg",
  RemoveBroadcastMsg: "RemoveBroadcasrMsg",
  GetValidateUserInfos: "GetValidateUserInfos",
  GetValidateGMInfos: "GetValidateGMInfos",
  UserTransferCoins: "UserTransferCoins",
  GetUserGiftRecords: "GetUserGiftRecords",
  GetUserPlayRecords: "GetUserPlayRecords",
  GetScores: "GetScores",
  ExportBillRecords: "ExportBillRecords",
  GetUserBillRecords: "GetUserBillRecords",
  GetGMBillRecords: "GetGMBillRecords",
  GetMachineBillRecords: "GetMachineBillRecords",
  QueryScore: "QueryScore",
  CanUserTransferUserCoins: "CanUserTransferUserCoins",
  GetRemoteClients: "GetRemoteClients",
  KickoutRemoteClient: "KickoutRemoteClient",
  KickoutGuoZhao: "KickoutGuoZhao",
  SaveGameInfo: "SaveGameInfo",
  GetDefinedKey: "GetDefinedKey",
  GetBroadcasts: "GetBroadcasts",
  ExchangeTrialToFormal: "ExchangeTrialToFormal",
  ExchangeFormalToTrial: "ExchangeFormalToTrial",
  ExchangeBetRewardToFormal: "ExchangeBetRewardToFormal",
  ExchangeUniPlayToFormal: "ExchangeUniPlayToFormal",
  ExchangeFormalToUniPlay: "ExchangeFormalToUniPlay",
  StartUniPlay: "StartUniPlay",
  StopUniPlay: "StopUniPlay",
  CheckConnectState: "CheckConnectState",
  NotifySync: "NotifySync",
  GateServerCloseClient: "GateServerCloseClient",
  GateServerCloseManager: "GateServerCloseManager",
  GateServerNoticeCloseClient: "GateServerNoticeCloseClient",
  GetUnknownOutScore: "GetUnknownOutScore",
  RecordUnknownOutScor: "RecordUnknownOutScore",
  BookMachine: "BookMachine",
  UnbookMachine: "UnbookMachine",
  PayBookMachines: "PayBookMachines",
  MachineToken: "MachineToken",
  GetBonusBroadcast: "GetBonusBroadcast",
};
